import './FormField.scss';

export default function FormField({
    label,
    type = 'text',
    value,
    onChange,
    placeholder,
    autoComplete,
    rightElement,
    error,
    hint,
    maxLength,
    inputMode,
    autoCapitalize,
    spellCheck,
    options,
    optionGroups,
    disabled,
    inline = false,
    className = '',
    minWidth,
}) {
    const wrapClass = [
        'ui-form-field__input-wrap',
        error && 'ui-form-field__input-wrap--error',
        rightElement && 'ui-form-field__input-wrap--with-action',
    ].filter(Boolean).join(' ');

    const fieldClass = [
        'ui-form-field',
        inline && 'ui-form-field--inline',
        className,
    ].filter(Boolean).join(' ');

    const style = minWidth ? { minWidth } : undefined;

    const renderSelect = () => {
        if (optionGroups?.length) {
            return (
                <select
                    className="ui-form-field__input"
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                >
                    {optionGroups.map((group) => (
                        group.options?.length ? (
                            <optgroup key={group.label || 'group'} label={group.label}>
                                {group.options.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </optgroup>
                        ) : null
                    ))}
                </select>
            );
        }

        return (
            <select
                className="ui-form-field__input"
                value={value}
                onChange={onChange}
                disabled={disabled}
            >
                {options?.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        );
    };

    return (
        <label className={fieldClass} style={style}>
            {label && <span className="ui-form-field__label">{label}</span>}
            <div className={wrapClass}>
                {options || optionGroups ? renderSelect() : (
                    <input
                        className="ui-form-field__input"
                        type={type}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        autoComplete={autoComplete}
                        maxLength={maxLength}
                        inputMode={inputMode}
                        autoCapitalize={autoCapitalize}
                        spellCheck={spellCheck}
                        disabled={disabled}
                    />
                )}
                {rightElement && (
                    <div className="ui-form-field__action">{rightElement}</div>
                )}
            </div>
            {hint && !error && <span className="ui-form-field__hint">{hint}</span>}
            {error && <span className="ui-form-field__error">{error}</span>}
        </label>
    );
}
